<template>
  <b-card title="Histórico de Geração em Lote">
    <div class="custom-search d-flex justify-content-between mb-1">
      <b-button
        variant="outline-secondary"
        @click="$router.push({ name: 'mensalidades-dashboard' })"
      >
        <feather-icon icon="ArrowLeftIcon" class="mr-50" />
        Voltar
      </b-button>
      
      <b-form-group class="mb-0">
        <b-form-input
          v-model="searchTerm"
          placeholder="Pesquisar..."
          type="text"
          class="d-inline-block w-auto"
        />
      </b-form-group>
    </div>

    <vue-good-table
      :columns="columns"
      :rows="logs"
      :rtl="direction"
      style-class="vgt-table striped"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm
      }"
      :pagination-options="{
        enabled: true,
        perPage: 10
      }"
      :sort-options="{
        enabled: true,
        initialSortBy: {field: 'dataHora', type: 'desc'}
      }"
    >
      <template
        slot="table-row"
        slot-scope="props"
      >
        <span v-if="props.column.field === 'dataHora'">
          {{ formatDate(props.row.dataHora) }}
        </span>

        <span v-else-if="props.column.field === 'status'">
          <b-badge :variant="statusVariant(props.row.status)">
            {{ props.row.status }}
          </b-badge>
        </span>

        <span v-else-if="props.column.field === 'progresso'">
           <div class="d-flex align-items-center">
             <div class="flex-grow-1 mr-1">
               <b-progress
                  :value="props.row.totalProcessado"
                  :max="props.row.totalRegistros"
                  variant="primary"
                  height="10px"
                  animated
                  v-if="props.row.status === 'PROCESSANDO'"
               />
               <span v-else>{{ props.row.totalProcessado }} / {{ props.row.totalRegistros }}</span>
             </div>
           </div>
        </span>

        <span v-else-if="props.column.field === 'actions'">
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="flat-primary"
            class="btn-icon"
            v-b-tooltip.hover
            title="Ver Detalhes"
            @click="verDetalhes(props.row)"
          >
            <feather-icon icon="EyeIcon" />
          </b-button>
        </span>
      </template>
    </vue-good-table>

    <!-- Modal de Relatório Removido (Agora é uma página própria) -->
  </b-card>
</template>

<script>
import {
  BCard, BButton, BBadge, BProgress, BRow, BCol, BModal, BFormGroup, BFormInput, VBTooltip,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import Ripple from 'vue-ripple-directive'
import valorFaixaVigenciaServices from '@/api/financial/valorFaixaVigenciaServices'

export default {
  components: {
    BCard, BButton, BBadge, BProgress, BRow, BCol, BModal, BFormGroup, BFormInput, VueGoodTable,
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      searchTerm: '',
      logs: [],
      showReport: false,
      currentLog: null,
      columns: [
        { label: 'Data/Hora', field: 'dataHora' },
        { label: 'Status', field: 'status', thClass: 'text-center', tdClass: 'text-center' },
        { label: 'Progresso', field: 'progresso', thClass: 'text-center' },
        { label: 'Sucessos', field: 'totalSucesso', type: 'number', thClass: 'text-center', tdClass: 'text-center' },
        { label: 'Erros', field: 'totalErros', type: 'number', thClass: 'text-center', tdClass: 'text-center' },
        { label: 'Ações', field: 'actions', thClass: 'text-center', tdClass: 'text-center' },
      ],
    }
  },
  computed: {
    direction() {
      return this.$store.state.appConfig.isRTL
    },
  },
  mounted() {
    this.fetchLogs()
  },
  methods: {
    async fetchLogs() {
      try {
        const { data } = await valorFaixaVigenciaServices.findAllLogs()
        this.logs = data
      } catch (err) {
        console.error('Erro ao carregar logs', err)
      }
    },
    verDetalhes(row) {
      this.$router.push({ name: 'mensalidades-log-detalhe', params: { id: row.id } })
    },
    formatDate(date) {
      if (!date) return '-'
      return new Date(date).toLocaleString('pt-BR')
    },
    statusVariant(status) {
      if (status === 'CONCLUIDO') return 'success'
      if (status === 'PROCESSANDO') return 'primary'
      if (status === 'ERRO') return 'danger'
      return 'warning'
    },
    itemStatusVariant(status) {
      if (status === 'SUCESSO') return 'light-success'
      if (status === 'IGNORADO') return 'light-warning'
      return 'light-danger'
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
